module.exports = __webpack_public_path__ + "static/media/icon-play-blue.0a832900.svg";